import { Link, useNavigate } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import type { NavEntry } from '@/app/navigation';
import { ICONS } from '@/components/ui/icons';
import { cn } from '@/lib/cn';
import { useHotkey } from '@/lib/hotkeys';

import { NAV_ROW, NAV_ROW_ICON, NAV_ROW_LINK } from './nav-styles';

import { UnreadBadge } from '@/features/notifications/UnreadBadge';

export function SidebarLink({ entry }: { entry: NavEntry }): ReactNode {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const Icon = ICONS[entry.icon];

  useHotkey(entry.shortcut, () => {
    void navigate({ to: entry.to });
  });

  return (
    <Link
      to={entry.to}
      data-testid={`nav-${entry.id}`}
      title={entry.shortcut ? t('nav.shortcutLabel', { keys: entry.shortcut }) : undefined}
      activeOptions={{ exact: entry.to === '/' }}
      className={cn(NAV_ROW_LINK, NAV_ROW, 'px-2')}
    >
      <Icon aria-hidden className={NAV_ROW_ICON} />
      <span className="flex-1 truncate">{t(entry.labelKey)}</span>
      <UnreadBadge navId={entry.id} />
    </Link>
  );
}
